module.exports = __webpack_public_path__ + "static/assets/64764c0e8dd11a31d0141c93ccb48a70.png";